import { createApi } from '@reduxjs/toolkit/query/react'
import { ADD_ATTENDANCE, DELETE_ATTENDANCE, UPDATE_ATTENDANCE } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const attendanceApi = createApi({
    reducerPath: 'attendanceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client/attendance",
    }),
    endpoints: (builder) => ({

        // add attendance
        addAttendance: builder.mutation({
            query: ({ clientId, data }) => ({
                method: "POST",
                url: `${ADD_ATTENDANCE}/${clientId}`,
                data
            }),
        }),

        // update attendance
        updateAttendance: builder.mutation({
            query: ({ attendanceId, attendance }) => ({
                method: "PUT",
                url: `${UPDATE_ATTENDANCE}/${attendanceId}/${attendance}`
            }),
        }),

        // delete attendance
        deleteAttendance: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${DELETE_ATTENDANCE}/${id}`
            }),
        }),
    }),
})

export const {
    useAddAttendanceMutation,
    useUpdateAttendanceMutation,
    useDeleteAttendanceMutation

} = attendanceApi;